import { ProjectService } from "./ProjectService";

export type { IProjectService } from "./IProjectService";

export const projectService = new ProjectService();
